import React from 'react'
import { ModalBody as ReactstrapModalBody, ModalBodyProps } from 'reactstrap'

export const ModalBody: React.FC<ModalBodyProps> = props => {
  return <ReactstrapModalBody {...props} />
}
